/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { PracticalExamAttachmentPagesCountDto } from '../models';
/**
 * ExamineeExamPreviewApi - axios parameter creator
 * @export
 */
export const ExamineeExamPreviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a watermarked PNG of the given PDF page. Access rules identical to the pages-count endpoint. 
         * @summary Render a single PDF page (with watermark) of an attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeAttachmentPagePreview: async (examId: string, attachmentId: number, pageIndex: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('getExamineeAttachmentPagePreview', 'examId', examId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getExamineeAttachmentPagePreview', 'attachmentId', attachmentId)
            // verify required parameter 'pageIndex' is not null or undefined
            assertParamExists('getExamineeAttachmentPagePreview', 'pageIndex', pageIndex)
            const localVarPath = `/api/v2/examinees/exams/{examId}/attachments/{attachmentId}/pages/{pageIndex}`
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"pageIndex"}}`, encodeURIComponent(String(pageIndex)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the page count for a PDF attachment that belongs to a report shared with the currently authenticated examinee. Access requires: - Authenticated user equals the exam participant - Exam status is STARTED - The attachment\'s parent report is shared with this individual exam 
         * @summary Number of pages in a PDF attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeAttachmentPagesCount: async (examId: string, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('getExamineeAttachmentPagesCount', 'examId', examId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getExamineeAttachmentPagesCount', 'attachmentId', attachmentId)
            const localVarPath = `/api/v2/examinees/exams/{examId}/attachments/{attachmentId}/pages-count`
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamineeExamPreviewApi - functional programming interface
 * @export
 */
export const ExamineeExamPreviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamineeExamPreviewApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a watermarked PNG of the given PDF page. Access rules identical to the pages-count endpoint. 
         * @summary Render a single PDF page (with watermark) of an attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamineeAttachmentPagePreview(examId: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamineeAttachmentPagePreview(examId, attachmentId, pageIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamineeExamPreviewApi.getExamineeAttachmentPagePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the page count for a PDF attachment that belongs to a report shared with the currently authenticated examinee. Access requires: - Authenticated user equals the exam participant - Exam status is STARTED - The attachment\'s parent report is shared with this individual exam 
         * @summary Number of pages in a PDF attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamineeAttachmentPagesCount(examId: string, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamAttachmentPagesCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamineeAttachmentPagesCount(examId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamineeExamPreviewApi.getExamineeAttachmentPagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamineeExamPreviewApi - factory interface
 * @export
 */
export const ExamineeExamPreviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamineeExamPreviewApiFp(configuration)
    return {
        /**
         * Returns a watermarked PNG of the given PDF page. Access rules identical to the pages-count endpoint. 
         * @summary Render a single PDF page (with watermark) of an attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeAttachmentPagePreview(examId: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getExamineeAttachmentPagePreview(examId, attachmentId, pageIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the page count for a PDF attachment that belongs to a report shared with the currently authenticated examinee. Access requires: - Authenticated user equals the exam participant - Exam status is STARTED - The attachment\'s parent report is shared with this individual exam 
         * @summary Number of pages in a PDF attachment shared with the authenticated examinee
         * @param {string} examId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeAttachmentPagesCount(examId: string, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto> {
            return localVarFp.getExamineeAttachmentPagesCount(examId, attachmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamineeExamPreviewApi - interface
 * @export
 * @interface ExamineeExamPreviewApi
 */
export interface ExamineeExamPreviewApiInterface {
    /**
     * Returns a watermarked PNG of the given PDF page. Access rules identical to the pages-count endpoint. 
     * @summary Render a single PDF page (with watermark) of an attachment shared with the authenticated examinee
     * @param {string} examId 
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamPreviewApiInterface
     */
    getExamineeAttachmentPagePreview(examId: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Returns the page count for a PDF attachment that belongs to a report shared with the currently authenticated examinee. Access requires: - Authenticated user equals the exam participant - Exam status is STARTED - The attachment\'s parent report is shared with this individual exam 
     * @summary Number of pages in a PDF attachment shared with the authenticated examinee
     * @param {string} examId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamPreviewApiInterface
     */
    getExamineeAttachmentPagesCount(examId: string, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto>;

}

/**
 * ExamineeExamPreviewApi - object-oriented interface
 * @export
 * @class ExamineeExamPreviewApi
 * @extends {BaseAPI}
 */
export class ExamineeExamPreviewApi extends BaseAPI implements ExamineeExamPreviewApiInterface {
    /**
     * Returns a watermarked PNG of the given PDF page. Access rules identical to the pages-count endpoint. 
     * @summary Render a single PDF page (with watermark) of an attachment shared with the authenticated examinee
     * @param {string} examId 
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamPreviewApi
     */
    public getExamineeAttachmentPagePreview(examId: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig) {
        return ExamineeExamPreviewApiFp(this.configuration).getExamineeAttachmentPagePreview(examId, attachmentId, pageIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the page count for a PDF attachment that belongs to a report shared with the currently authenticated examinee. Access requires: - Authenticated user equals the exam participant - Exam status is STARTED - The attachment\'s parent report is shared with this individual exam 
     * @summary Number of pages in a PDF attachment shared with the authenticated examinee
     * @param {string} examId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamPreviewApi
     */
    public getExamineeAttachmentPagesCount(examId: string, attachmentId: number, options?: RawAxiosRequestConfig) {
        return ExamineeExamPreviewApiFp(this.configuration).getExamineeAttachmentPagesCount(examId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
}

